import secureLocalStorage from "react-secure-storage";
import * as React from "react";
import { DropDownList } from "@progress/kendo-react-dropdowns";
export default class ActionQualitativeImpact extends React.Component {
  handleChange = (e) => {
    this.props.onChange({
      dataItem: this.props.dataItem,
      field: this.props.field,
      syntheticEvent: e.syntheticEvent,
      value: e.value,
    });
  };

  handleEditCell = () => {
    if (this.props.dataItem.isOpen === "Open" || this.props.dataItem.isOpen===true) {
      this.props.onEditCell(this.props.dataItem, this.props.field);
    }
  };

  render() {
    const { dataItem, field } = this.props;
    const loginUserId = parseInt(secureLocalStorage.getItem("loginUserId"));
    const ownerId = dataItem.userId;
    const riskOwnerId = this.props.riskDetails
      ? this.props.riskDetails.userId
      : null;
    const dataValue =
      dataItem[field] === null || dataItem[field] === undefined
        ? ""
        : dataItem[field];
    const impact =
      dataItem.impactResponse &&
      dataItem.impactResponse.find((item) => item.name == field);
    let access = false;
    let tooltipVal = "";
    if (impact) {
      access = true;
      let temp =
        impact.qualityImpactList &&
        impact.qualityImpactList.find((ql) => ql.id == dataValue);
      if (temp) {
        tooltipVal = temp.description;
      }
    }
    if (this.props.field && this.props.field === this.props.dataItem.inEdit) {
      return (
        <td>
          <DropDownList
            style={{ width: "100px" }}
            onChange={this.handleChange.bind(this)}
            // value={value}
            data={[0, 1, 2, 3, 4, 5, 6, 7, 8].slice(
              0,
              this.props.heatMapCount + 1
            )}
          />
        </td>
      );
    } else {
      if (
        (loginUserId === ownerId || loginUserId === riskOwnerId) &&
        this.props.dataItem.isOpen === true &&
        access
      ) {
        return (
          <td onClick={this.handleEditCell} title={tooltipVal}>
            {dataValue ? dataValue : "0"}
          </td>
        );
      } else {
        return this.props.dataItem.role === "View Only" ||
          this.props.dataItem.role === "Standard User" ||
          this.props.dataItem.isOpen === false ||
          !access ? (
          <td title={tooltipVal}>{dataValue ? dataValue : "0"}</td>
        ) : (
          <td onClick={this.handleEditCell} title={tooltipVal}>
            {dataValue ? dataValue : "0"}
          </td>
        );
      }
    }
  }
}
